/**
 * Generates a simple, memorable and unique promo code from user information
 * Format: FIRSTNAME + random alphanumeric (6 chars uppercase)
 * Example: LORIS-A7B9C2
 */
export function generatePromoCode(
  firstName: string,
  _lastName: string,
  _email: string
): string {
  // Clean and format first name (remove accents, uppercase, max 8 chars)
  const cleanFirstName = firstName
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z]/g, "")
    .toUpperCase()
    .slice(0, 8);

  // Generate random alphanumeric string (6 chars)
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let random = "";
  for (let i = 0; i < 6; i++) {
    random += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return `${cleanFirstName}-${random}`;
}
